import CashierSteps from "../../../../../modules/Account/components/CashierSteps/CashierSteps";
import { MOBILE_HISTORY_WITHDRAWAL_STEPS } from "./mobileHistoryTransactionInfoConstants";

function MobileHistoryWithdrawalSteps() {
    return <div className={'mt-5 w-100'}>
        <CashierSteps steps={MOBILE_HISTORY_WITHDRAWAL_STEPS}/>
    </div>
}

export default MobileHistoryWithdrawalSteps;
